module.exports = __webpack_public_path__ + "static/media/background2.2e1f6ff2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background2.jpeg
// module id = 258
// module chunks = 0